import { c as _c } from "react/compiler-runtime";
export default function ChartIcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M27.5 29a1 1 0 0 1 1 1v35h40a1 1 0 0 1 0 2h-41a1 1 0 0 1-1-1V30a1 1 0 0 1 1-1zm37.877 6.07a1.71 1.71 0 0 1 1.446 1.444c.448 2.984.398 6.731-.152 11.137a1 1 0 0 1-1.116.87 1 1 0 0 1-.583-.286.995.995 0 0 1-.286-.83c.438-3.515.55-6.57.332-9.11L52.906 50.405a.999.999 0 0 1-1.414 0L48 46.914l-12.73 12.73a.993.993 0 0 1-.708.293.995.995 0 0 1-.707-.293 1 1 0 0 1 0-1.414l13.438-13.437a.999.999 0 0 1 1.414 0l3.492 3.492.033-.032.25-.25.097-.097.515-.516.158-.158.346-.346.188-.187.4-.401.433-.433.942-.941.5-.502 2.907-2.906.521-.521.51-.51.492-.492.471-.471.446-.447.418-.417.383-.384.504-.503.613-.614.21-.209.072-.073c-2.54-.218-5.6-.107-9.119.331a1 1 0 0 1-.248-1.984c4.408-.55 8.156-.6 11.136-.152z" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden={true} className={className} fill="currentColor" height="96" viewBox="0 0 96 96" width="96" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}